import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

export const CreatorFilter = ({ creators, value, onChange }) => (
  <Select value={value || "all"} onValueChange={(v) => onChange(v === "all" ? "" : v)}>
    <SelectTrigger className="rounded-none w-full sm:w-56 bg-canvas border-line2" data-testid="created-by-filter">
      <SelectValue placeholder="Created by" />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all" data-testid="created-by-option-all">Created by: Everyone</SelectItem>
      {creators.map((c) => (
        <SelectItem key={c.id} value={c.id} data-testid={`created-by-option-${c.id}`}>Created by: {c.name}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);
